import React, { useContext } from 'react';
import { ThemeModeContext, useTheme } from '@pentester.com/grommet-theme';

export const DepartmentOfDefense = () => {
  const { mode } = useContext(ThemeModeContext);
  const theme = useTheme();

  return (
    <svg viewBox="0 0 1139 424" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M588.44 109.96V152.611C588.44 154.007 588.504 155.635 588.631 157.494C588.756 159.354 589.073 161.266 589.579 163.223C590.083 165.185 590.795 167.111 591.71 169.003C592.625 170.896 593.874 172.59 595.451 174.085C597.027 175.582 598.974 176.778 601.279 177.672C603.583 178.57 606.38 179.018 609.664 179.018C613.833 179.018 617.323 178.406 620.133 177.173C622.944 175.945 625.216 174.185 626.953 171.891C628.689 169.602 629.939 166.829 630.698 163.571C631.451 160.318 631.833 156.665 631.833 152.611V109.96H636V152.611C636 156.864 635.575 160.816 634.722 164.468C633.87 168.122 632.43 171.314 630.411 174.036C628.389 176.758 625.688 178.904 622.312 180.463C618.933 182.023 614.715 182.804 609.665 182.804C605.685 182.804 602.274 182.271 599.432 181.209C596.589 180.147 594.236 178.77 592.373 177.075C590.509 175.381 589.044 173.438 587.969 171.245C586.894 169.053 586.076 166.846 585.507 164.618C584.937 162.394 584.589 160.234 584.465 158.14C584.335 156.049 584.274 154.205 584.274 152.611V109.96L588.44 109.96Z"
        fill={`${
          mode === `light` ? `#141414` : theme.global.colors[`light-3`]
        }`}
      />
      <path
        d="M702.06 130.29C701.934 127.234 701.317 124.576 700.215 122.317C699.107 120.06 697.609 118.167 695.714 116.637C693.818 115.11 691.56 113.964 688.938 113.199C686.318 112.436 683.459 112.054 680.365 112.054C678.469 112.054 676.433 112.286 674.254 112.751C672.075 113.217 670.051 114.031 668.19 115.192C666.328 116.357 664.795 117.916 663.595 119.876C662.395 121.835 661.796 124.278 661.796 127.201C661.796 130.058 662.459 132.382 663.786 134.177C665.111 135.97 666.847 137.417 668.997 138.511C671.144 139.608 673.606 140.489 676.385 141.15C679.167 141.816 681.974 142.448 684.817 143.045C687.722 143.644 690.551 144.357 693.297 145.188C696.046 146.02 698.507 147.148 700.687 148.576C702.868 150.005 704.62 151.864 705.947 154.156C707.272 156.447 707.933 159.322 707.933 162.776C707.933 166.499 707.177 169.621 705.662 172.143C704.147 174.67 702.235 176.728 699.928 178.32C697.623 179.917 695.064 181.06 692.256 181.759C689.444 182.457 686.744 182.805 684.154 182.805C680.174 182.805 676.446 182.359 672.976 181.461C669.498 180.563 666.468 179.104 663.879 177.077C661.29 175.051 659.252 172.442 657.769 169.253C656.283 166.066 655.575 162.179 655.636 157.595H659.806C659.617 161.515 660.152 164.818 661.416 167.51C662.679 170.2 664.432 172.409 666.675 174.137C668.916 175.865 671.556 177.11 674.587 177.874C677.617 178.637 680.806 179.019 684.154 179.019C686.174 179.019 688.338 178.756 690.644 178.222C692.95 177.69 695.064 176.793 696.993 175.532C698.918 174.27 700.528 172.609 701.825 170.549C703.116 168.49 703.766 165.899 703.766 162.777C703.766 159.788 703.102 157.345 701.775 155.452C700.449 153.557 698.696 152.03 696.518 150.867C694.339 149.707 691.874 148.777 689.127 148.079C686.381 147.381 683.553 146.734 680.65 146.134C677.809 145.538 674.996 144.84 672.218 144.041C669.435 143.244 666.972 142.165 664.826 140.804C662.679 139.442 660.944 137.681 659.618 135.522C658.291 133.364 657.626 130.589 657.626 127.201C657.626 123.813 658.303 120.908 659.663 118.482C661.022 116.057 662.789 114.097 664.97 112.603C667.148 111.108 669.596 110.011 672.312 109.314C675.025 108.615 677.712 108.266 680.365 108.266C683.902 108.266 687.199 108.684 690.266 109.512C693.327 110.344 696.012 111.639 698.319 113.399C700.624 115.16 702.47 117.434 703.859 120.225C705.249 123.014 706.04 126.37 706.23 130.29H702.06L702.06 130.29Z"
        fill={`${
          mode === `light` ? `#141414` : theme.global.colors[`light-3`]
        }`}
      />
      <path
        d="M607.89 266.67C611.187 266.67 614.499 266.135 617.831 265.057C621.159 263.983 624.175 262.181 626.878 259.647C629.582 257.118 631.774 253.719 633.456 249.456C635.135 245.191 635.98 239.831 635.98 233.382C635.98 228.323 635.499 223.986 634.544 220.38C633.589 216.773 632.335 213.74 630.785 211.275C629.234 208.816 627.455 206.873 625.445 205.45C623.433 204.031 621.357 202.937 619.212 202.172C617.071 201.412 614.927 200.907 612.786 200.666C610.643 200.421 608.714 200.3 607.002 200.3H588.9V266.67L607.89 266.67ZM584.549 196.347H607.693C614.022 196.347 619.278 197.386 623.468 199.469C627.655 201.548 630.999 204.324 633.506 207.791C636.012 211.26 637.774 215.215 638.798 219.651C639.818 224.089 640.33 228.668 640.33 233.381C640.33 238.652 639.686 243.561 638.401 248.101C637.116 252.644 635.121 256.579 632.418 259.908C629.714 263.238 626.3 265.858 622.18 267.763C618.061 269.672 613.164 270.624 607.493 270.624H584.549L584.549 196.347Z"
        fill={`${
          mode === `light` ? `#141414` : theme.global.colors[`light-3`]
        }`}
      />
      <path
        d="M700.43 200.29H657.31V230.05H697.86V234H657.31V266.67H700.92V270.62H652.96V196.34H700.43V200.29Z"
        fill={`${
          mode === `light` ? `#141414` : theme.global.colors[`light-3`]
        }`}
      />
      <path
        d="M720.43 233.58H745.257C748.422 233.58 751.107 233.078 753.318 232.072C755.524 231.067 757.287 229.766 758.607 228.172C759.925 226.576 760.882 224.807 761.476 222.866C762.071 220.924 762.367 218.981 762.367 217.039C762.367 215.653 762.168 214.005 761.771 212.096C761.377 210.19 760.587 208.351 759.4 206.582C758.21 204.814 756.544 203.326 754.405 202.111C752.262 200.896 749.41 200.29 745.849 200.29H720.43V233.58L720.43 233.58ZM716.081 196.337H746.147C748.122 196.337 750.317 196.582 752.724 197.064C755.129 197.55 757.372 198.54 759.448 200.029C761.525 201.523 763.254 203.638 764.641 206.376C766.026 209.117 766.719 212.706 766.719 217.143C766.719 223.664 764.804 228.693 760.983 232.229C757.158 235.764 751.684 237.536 744.561 237.536H720.43V270.615H716.08L716.081 196.337Z"
        fill={`${
          mode === `light` ? `#141414` : theme.global.colors[`light-3`]
        }`}
      />
      <path
        d="M824.56 196.34V200.29H799.64V270.62H795.29V200.29H770.46V196.34H824.56Z"
        fill={`${
          mode === `light` ? `#141414` : theme.global.colors[`light-3`]
        }`}
      />
      <path
        d="M862.28 233.48C862.28 238.265 862.942 242.772 864.262 247.001C865.579 251.233 867.49 254.924 869.998 258.081C872.5 261.236 875.567 263.749 879.194 265.622C882.818 267.495 886.943 268.429 891.559 268.429C896.173 268.429 900.276 267.495 903.871 265.622C907.463 263.749 910.512 261.236 913.02 258.081C915.524 254.924 917.436 251.233 918.755 247.001C920.073 242.771 920.735 238.265 920.735 233.48C920.735 228.695 920.073 224.187 918.755 219.955C917.436 215.725 915.524 212.031 913.02 208.876C910.512 205.72 907.463 203.207 903.871 201.334C900.276 199.462 896.172 198.525 891.559 198.525C886.943 198.525 882.818 199.462 879.194 201.334C875.567 203.207 872.5 205.72 869.998 208.876C867.49 212.031 865.579 215.726 864.262 219.955C862.942 224.187 862.28 228.695 862.28 233.48ZM925.088 233.48C925.088 238.888 924.327 243.969 922.814 248.72C921.295 253.471 919.105 257.594 916.237 261.099C913.367 264.6 909.857 267.358 905.702 269.368C901.547 271.38 896.832 272.386 891.56 272.386C886.283 272.386 881.553 271.38 877.368 269.368C873.178 267.358 869.652 264.6 866.784 261.099C863.916 257.594 861.723 253.471 860.205 248.72C858.688 243.969 857.931 238.888 857.931 233.48C857.931 228.07 858.688 222.99 860.205 218.239C861.723 213.488 863.916 209.361 866.784 205.86C869.652 202.358 873.178 199.601 877.368 197.587C881.553 195.576 886.284 194.57 891.56 194.57C896.831 194.57 901.547 195.576 905.702 197.587C909.857 199.601 913.367 202.358 916.237 205.86C919.105 209.361 921.295 213.488 922.814 218.239C924.328 222.99 925.088 228.07 925.088 233.48Z"
        fill={`${
          mode === `light` ? `#141414` : theme.global.colors[`light-3`]
        }`}
      />
      <path
        d="M980.84 200.29H940.88V230.05H976.88V234H940.88V270.62H936.53V196.34H980.84V200.29Z"
        fill={`${
          mode === `light` ? `#141414` : theme.global.colors[`light-3`]
        }`}
      />
      <path
        d="M614.97 347.05C617.293 347.05 619.545 346.658 621.732 345.865C623.917 345.076 625.863 343.765 627.57 341.933C629.277 340.103 630.643 337.714 631.67 334.769C632.694 331.823 633.205 328.231 633.205 323.995C633.205 320.116 632.846 316.612 632.131 313.487C631.413 310.364 630.234 307.687 628.596 305.46C626.957 303.233 624.79 301.527 622.093 300.343C619.392 299.154 616.062 298.563 612.101 298.563H600.629V347.05L614.97 347.05ZM616.098 284.339C620.81 284.339 625.199 285.132 629.263 286.712C633.325 288.29 636.843 290.661 639.81 293.822C642.784 296.983 645.103 300.935 646.779 305.675C648.452 310.416 649.289 315.985 649.289 322.378C649.289 327.98 648.604 333.152 647.24 337.893C645.871 342.634 643.807 346.728 641.041 350.177C638.277 353.624 634.826 356.336 630.697 358.309C626.563 360.289 621.697 361.274 616.098 361.274H584.546V284.339H616.098H616.098Z"
        fill={`${
          mode === `light` ? `#141414` : theme.global.colors[`light-3`]
        }`}
      />
      <path
        d="M679.98 298.56V315.05H715.42V328.2H679.98V347.05H719.42V361.28H663.9V284.34H718.6V298.56H679.98Z"
        fill={`${
          mode === `light` ? `#141414` : theme.global.colors[`light-3`]
        }`}
      />
      <path
        d="M751.48 298.56V316.34H782.11V329.49H751.48V361.28H735.4V284.34H786.82V298.56H751.48Z"
        fill={`${
          mode === `light` ? `#141414` : theme.global.colors[`light-3`]
        }`}
      />
      <path
        d="M815.89 298.56V315.05H851.33V328.2H815.89V347.05H855.33V361.28H799.8V284.34H854.51V298.56H815.89Z"
        fill={`${
          mode === `light` ? `#141414` : theme.global.colors[`light-3`]
        }`}
      />
      <path
        d="M919.48 335.96V284.34H934.54V361.28H918.461L888.04 309.77H887.831V361.28H872.771V284.34H888.75L919.281 335.96H919.48Z"
        fill={`${
          mode === `light` ? `#141414` : theme.global.colors[`light-3`]
        }`}
      />
      <path
        d="M966.1 342.31C966.986 344.105 968.165 345.564 969.634 346.673C971.099 347.789 972.824 348.614 974.807 349.151C976.787 349.69 978.835 349.96 980.954 349.96C982.387 349.96 983.924 349.835 985.564 349.584C987.201 349.332 988.738 348.847 990.173 348.129C991.607 347.414 992.8 346.425 993.759 345.165C994.715 343.91 995.191 342.31 995.191 340.372C995.191 338.287 994.56 336.599 993.295 335.308C992.033 334.014 990.38 332.936 988.331 332.075C986.28 331.213 983.956 330.458 981.361 329.813C978.767 329.164 976.136 328.448 973.474 327.657C970.741 326.94 968.081 326.058 965.485 325.016C962.89 323.976 960.566 322.628 958.517 320.978C956.466 319.324 954.814 317.26 953.55 314.782C952.283 312.303 951.655 309.303 951.655 305.782C951.655 301.833 952.457 298.404 954.062 295.493C955.665 292.585 957.766 290.16 960.363 288.218C962.959 286.281 965.894 284.844 969.173 283.908C972.448 282.977 975.729 282.507 979.006 282.507C982.832 282.507 986.502 282.958 990.021 283.856C993.535 284.756 996.66 286.21 999.394 288.218C1002.12 290.23 1004.29 292.798 1005.9 295.925C1007.5 299.047 1008.3 302.839 1008.3 307.293H992.734C992.596 304.995 992.134 303.087 991.352 301.58C990.564 300.074 989.523 298.886 988.226 298.025C986.93 297.162 985.442 296.553 983.769 296.195C982.098 295.834 980.268 295.655 978.288 295.655C976.994 295.655 975.695 295.8 974.399 296.085C973.099 296.374 971.921 296.877 970.863 297.595C969.804 298.314 968.933 299.211 968.252 300.286C967.568 301.364 967.226 302.73 967.226 304.381C967.226 305.891 967.499 307.112 968.046 308.045C968.592 308.979 969.666 309.842 971.273 310.633C972.877 311.422 975.096 312.213 977.931 313C980.765 313.793 984.472 314.799 989.045 316.02C990.411 316.306 992.308 316.827 994.731 317.583C997.155 318.335 999.562 319.541 1001.96 321.194C1004.34 322.845 1006.41 325.052 1008.15 327.819C1009.89 330.584 1010.76 334.122 1010.76 338.431C1010.76 341.952 1010.11 345.219 1008.82 348.237C1007.52 351.254 1005.59 353.859 1003.03 356.048C1000.47 358.242 997.291 359.945 993.503 361.167C989.712 362.388 985.323 362.998 980.339 362.998C976.309 362.998 972.399 362.476 968.61 361.435C964.819 360.395 961.472 358.761 958.569 356.533C955.665 354.306 953.363 351.471 951.655 348.021C949.947 344.571 949.128 340.477 949.197 335.736H964.767C964.767 338.321 965.211 340.515 966.1 342.31L966.1 342.31Z"
        fill={`${
          mode === `light` ? `#141414` : theme.global.colors[`light-3`]
        }`}
      />
      <path
        d="M1038.56 298.56V315.05H1074V328.2H1038.56V347.05H1078V361.28H1022.48V284.34H1077.2V298.56H1038.56Z"
        fill={`${
          mode === `light` ? `#141414` : theme.global.colors[`light-3`]
        }`}
      />
      <path
        d="M640.73 174.43H646.31V182.81H640.73V174.43Z"
        fill={`${
          mode === `light` ? `#141414` : theme.global.colors[`light-3`]
        }`}
      />
      <path
        d="M713.37 174.43H718.95V182.81H713.37V174.43Z"
        fill={`${
          mode === `light` ? `#141414` : theme.global.colors[`light-3`]
        }`}
      />
      <path
        d="M119.789 363L61.5332 192.48L61 139.798L119.951 302.01L119.789 363Z"
        fill={`${
          mode === `light`
            ? `url(#paint0_linear_478_110)`
            : theme.global.colors[`light-3`]
        }`}
      />
      <path
        d="M484.61 363L541.2 192.48L541.97 140.385L484.61 301.2V363Z"
        fill={`${
          mode === `light`
            ? `url(#paint1_linear_478_110)`
            : theme.global.colors[`light-3`]
        }`}
      />
      <path
        d="M384.02 218.64H227.89L211.967 176.936L202.151 151.229L304.721 117.741L409.191 151.229L384.02 218.64ZM304.862 61L65.3418 137.438L124.091 291.308H480.461L537.92 137.438L304.862 61Z"
        fill={`${
          mode === `light`
            ? `url(#paint2_linear_478_110)`
            : theme.global.colors[`light-3`]
        }`}
      />
      <path
        d="M126.799 301.22H477.14V362.44H126.796L126.799 301.22Z"
        fill={`${
          mode === `light`
            ? `url(#paint3_linear_478_110)`
            : theme.global.colors[`light-3`]
        }`}
      />
      <path
        d="M301.27 154.986V125.979L211.08 155.493L219.9 178.27L301.27 154.986Z"
        fill={`${
          mode === `light` ? `#717171` : theme.global.colors[`light-3`]
        }`}
      />
      <path
        d="M391.53 178.58L400.3 155.94L308.26 126.199V155.217L391.53 178.58Z"
        fill={`${
          mode === `light` ? `#717171` : theme.global.colors[`light-3`]
        }`}
      />
      <defs>
        <linearGradient
          id="paint0_linear_478_110"
          x1="61"
          y1="139.798"
          x2="119.951"
          y2="139.798"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#ADADAD" />
          <stop offset="1" stopColor="#717171" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_478_110"
          x1="484.61"
          y1="140.385"
          x2="541.97"
          y2="140.385"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#ADADAD" />
          <stop offset="1" stopColor="#717171" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_478_110"
          x1="65.3418"
          y1="61"
          x2="537.92"
          y2="61"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#ADADAD" />
          <stop offset="1" stopColor="#717171" />
        </linearGradient>
        <linearGradient
          id="paint3_linear_478_110"
          x1="126.796"
          y1="301.22"
          x2="477.14"
          y2="301.22"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#ADADAD" />
          <stop offset="1" stopColor="#717171" />
        </linearGradient>
      </defs>
    </svg>
  );
};
